import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from 'app/shared/shared.module';
import { MultiModulePickerComponent } from './multi-module-picker.component';
import { AssetDataPickerModule } from '../data-picker/asset-data-picker/asset-data-picker.module';
import { ContractDataPickerModule } from '../data-picker/contract-data-picker/contract-data-picker.module';
import { CustomerDataPickerModule } from '../data-picker/customer-data-picker/customer-data-picker.module';
import { OrganizationDataPickerModule } from '../data-picker/organization-data-picker/organization-data-picker.module';
import { PropertyDataPickerModule } from '../data-picker/property-data-picker/property-data-picker.module';
import { QuickCreateCustomerModule } from '../data-picker/quick-create-customer/quick-create-customer.module';
import { QuickCreateOrganizationModule } from '../data-picker/quick-create-organization/quick-create-organization.module';
import { QuickCreatePropertyModule } from '../data-picker/quick-create-property/quick-create-property.module';
import { JobDataPickerModule } from '../data-picker/job-data-picker/job-data-picker.module';
import { QuoteDataPickerModule } from '../data-picker/quote-data-picker/quote-data-picker.module';
import { RequestDataPickerModule } from '../data-picker/request-data-picker/request-data-picker.module';
import { ProjectDataPickerModule } from '../data-picker/project-data-picker/project-data-picker.module';



@NgModule({
  declarations: [
    MultiModulePickerComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    JobDataPickerModule,
    CustomerDataPickerModule,
    QuickCreateCustomerModule,
    OrganizationDataPickerModule,
    QuickCreateOrganizationModule,
    PropertyDataPickerModule,
    QuickCreatePropertyModule,
    AssetDataPickerModule,
    QuoteDataPickerModule,
    ContractDataPickerModule,
    RequestDataPickerModule,
    ProjectDataPickerModule
  ],
  exports: [
    MultiModulePickerComponent
  ]
})
export class MultiModulePickerModule { }
